module.exports = require("./mt.d.ts");